module.exports = "/static/assets/199f58b4a80fa56c5d8e032d6da5e9c2.svg";